export default "__VITE_ASSET__y7rQcgq8__"